import * as React from 'react';
import { useRefinementList } from 'react-instantsearch';
import { useMenu } from 'react-instantsearch';
import { IsRefinableItem } from '../helpers';

function CustomRefinementList({attribute, onLoad}) {
  const {items: allItems, refine} = useRefinementList({attribute});
  const allItemsRef = React.useRef(new Map());
  const initializedRef = React.useRef(false);
  const refinableItems = allItems.map(item => item.value);

  allItems.forEach(item => {
    allItemsRef.current.set(item.value, item);
  });

  React.useEffect(() => {
    if (allItems.length > 0 && !initializedRef.current) {
      onLoad?.(attribute);
      initializedRef.current = true;
    }
  }, [allItems, onLoad]);

  const handleClick = (value) => refine(value);

  return (
    <ul>
      {Array.from(allItemsRef.current.values()).map(item => {
        const isRefinable = IsRefinableItem(refinableItems, item);

        return (
          <li key={item.value} className={!isRefinable ? 'facet-empty' : 'with-value'}>
            <label>
              <input
                type="checkbox"
                checked={item.isRefined && item.count > 0}
                onChange={() => handleClick(item.value)}
                disabled={!isRefinable}
              />
              <span>{item.label}</span>
              <span className='ais-Menu-count'> ({item.count})</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

function CustomMenu({attribute, onLoad}) {
  const {items, refine} = useMenu({attribute});
  const allItemsRef = React.useRef(new Map());
  const initializedRef = React.useRef(false);

  const refinableItems = items.map(item => item.value);
  items.forEach(item => allItemsRef.current.set(item.value, item));

  const handleClick = (value) => refine(value);

  React.useEffect(() => {
    if (items.length > 0 && !initializedRef.current) {
      onLoad?.(attribute);
      initializedRef.current = true;
    }
  }, [items, onLoad]);

  return (
    <ul>
      {Array.from(allItemsRef.current.values()).map(item => {
        const isRefinable = IsRefinableItem(refinableItems, item);

        return (
          <li key={item.value} className={!isRefinable ? 'facet-empty' : 'with-value'}>
            <label>
              <input
                type="radio"
                name={attribute}
                checked={item.isRefined}
                onChange={() => handleClick(item.value)}
                disabled={!isRefinable}
              />
              <span>{item.label}</span>
              <span className='ais-Menu-count'> ({item.count})</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

function FilterWrapper(props) {
  const {label, children, kind, attribute} = props;
  const classNames = ['filter-wrapper', `filter-wrapper--${kind}`];
  return (
    <details className={classNames.join(' ')} data-attribute={attribute} data-kind={kind} open={true}>
      <summary>
        <strong>{label}</strong>
        <div className="filter-wrapper__arrow"></div>
      </summary>
      <div className='filter-wrapper__content'>
        {children}
      </div>
    </details>
  );
}

function CheckboxesFilter({label, attribute, onLoad}) {
  return (
    <FilterWrapper label={label} attribute={attribute} kind='checkboxes'>
      <CustomRefinementList attribute={attribute} onLoad={onLoad}/>
    </FilterWrapper>
  );
}

function RadioButtonsFilter({label, attribute, onLoad}) {
  return (
    <FilterWrapper label={label} attribute={attribute} kind='radio-buttons'>
      <CustomMenu attribute={attribute} onLoad={onLoad}/>
    </FilterWrapper>
  );
}

export default function Filter(props) {
  const {config, onLoad} = props;
  const {
    attribute = null,
    label,
    kind,
  } = config;

  if (!attribute) {
    return null;
  }

  switch (kind) {
    case 'radio':
      return <RadioButtonsFilter
        label={label}
        attribute={attribute}
        onLoad={onLoad}/>;
    case 'checkboxes':
      return <CheckboxesFilter
        label={label}
        attribute={attribute}
        onLoad={onLoad}/>;
    default:
      return null;
  }
}
